import {
  LoadingOverlayProps as MantineLoadingOverlayProps,
  LoadingOverlay as MantineLoadingOverlay,
} from '@mantine/core';

export type LoadingOverlayProps = MantineLoadingOverlayProps;

export const LoadingOverlay = MantineLoadingOverlay;

LoadingOverlay.displayName = 'LoadingOverlay';
